<template>
  <v-stepper-content step="1">
    <v-row>
      <v-col v-for="item in filteredCameraModels" :key="item.id">
        <v-card
          class="mb-12"
          height="250px"
          hover
          max-width="200"
          justify-content: center
          @click="select(item)"
        >
          <v-img contain max-width=200 :src="item.image" />
          <v-card-text>
            <span :class="selected === item.id ? 'red--text'
            : $vuetify.theme.dark ? 'white--text' : 'black--text'">
              <p class="subtitle-1">
              {{ item.title }}
              </p>
            </span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-btn
        class="ma-3"
        color="primary"
        @click="$emit('update:e1', 2)"
        rounded
        :disabled="selected === 0"
      >
        Next
      </v-btn>
    </v-row>
  </v-stepper-content>
</template>
<script>

export default {
  data() {
    return {
      selected: 0,
      cameraModels: [
        {
          id: 1,
          title: 'Ricoh Theta V',
          image: '/device_ricoh_theta_v.jpg',
          type: 'camera',
        },
        {
          id: 2,
          title: 'Ricoh Theta Z1',
          image: '/device_ricoh_theta_z1.jpg',
          type: 'camera',
        },
        {
          id: 4,
          title: 'Labpano Pilot Era',
          image: '/device_labpano_pilot_era.jpg',
          type: 'camera',
        },
        {
          id: 5,
          title: 'Labpano Pilot One (EE)',
          image: '/device_labpano_pilot_one.jpg',
          type: 'camera',
        },
        {
          id: 3,
          title: 'Generic Android',
          image: '/device_generic_android.jpg',
          type: 'mobile',
        },
        {
          id: 6,
          title: 'RealWear HMT-1',
          image: '/realwear_hmt1.png',
          type: 'headset',
        },
      ],
    };
  },
  props: {
    type: {
      type: String,
      required: false,
    },
  },
  computed: {
    filteredCameraModels() {
      return this.cameraModels.filter((el) => el.type === this.type);
    },
  },
  methods: {
    select(model) {
      this.selected = model.id;
      this.$store.commit('cameraModel', model.title);
    },
  },
};
</script>
<style scoped>
</style>
